import { c as _c } from "react/compiler-runtime";
import React from "react";
import { SingleWaveDropClose } from "./SingleWaveDropClose";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { SingleWaveDropTab } from "./SingleWaveDrop";
import { ApiWave } from "@/generated/models/ApiWave";
import { ApiDropType } from "@/generated/models/ApiDropType";
import { SingleWaveDropInfoContainer } from "./SingleWaveDropInfoContainer";
import { SingleWaveDropInfoDetails } from "./SingleWaveDropInfoDetails";
import { SingleWaveDropInfoAuthorSection } from "./SingleWaveDropInfoAuthorSection";
import { SingleWaveDropInfoActions } from "./SingleWaveDropInfoActions";
import { SingleWaveDropInfoContent } from "./SingleWaveDropInfoContent";
import { SingleWaveDropVotes } from "./SingleWaveDropVotes";
import WaveDropDeleteButton from "@/components/utils/button/WaveDropDeleteButton";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
interface SingleWaveDropInfoPanelProps {
  readonly drop: ExtendedDrop;
  readonly wave: ApiWave | null;
  readonly activeTab: SingleWaveDropTab;
  readonly onClose: () => void;
}
export const SingleWaveDropInfoPanel: React.FC<SingleWaveDropInfoPanelProps> = t0 => {
  const $ = _c(25);
  const {
    drop,
    wave,
    activeTab,
    onClose
  } = t0;
  const {
    canDelete
  } = useDropInteractionRules(drop);
  let t1;
  if ($[0] !== onClose) {
    t1 = <div className="tw-hidden lg:tw-block"><SingleWaveDropClose onClose={onClose} /></div>;
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== drop) {
    t2 = <SingleWaveDropInfoContent drop={drop} />;
    $[2] = drop;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== drop) {
    t3 = <div className="tw-px-6"><SingleWaveDropVotes drop={drop} /></div>;
    $[4] = drop;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== drop || $[7] !== wave) {
    t4 = <div className="tw-px-6 tw-mt-4"><SingleWaveDropInfoAuthorSection drop={drop} wave={wave} /></div>;
    $[6] = drop;
    $[7] = wave;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== drop) {
    t5 = <SingleWaveDropInfoActions drop={drop} />;
    $[9] = drop;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== drop) {
    t6 = <div className="tw-mt-2"><SingleWaveDropInfoDetails drop={drop} /></div>;
    $[11] = drop;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== canDelete || $[14] !== drop) {
    t7 = canDelete && drop.drop_type !== ApiDropType.Winner && <div className="tw-w-full tw-px-6 tw-pb-6 tw-pt-6 tw-border-t tw-border-iron-800 tw-border-solid tw-border-x-0 tw-border-b-0"><WaveDropDeleteButton drop={drop} /></div>;
    $[13] = canDelete;
    $[14] = drop;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== activeTab || $[17] !== t1 || $[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t7) {
    t8 = <SingleWaveDropInfoContainer activeTab={activeTab}>{t1}{t2}{t3}{t4}{t5}{t6}{t7}</SingleWaveDropInfoContainer>;
    $[16] = activeTab;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
};